module.exports = __webpack_public_path__ + "img/znmj.08fa6ccc.jpg";